<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> تعداد <span class="ml-1 mr-1 info--text"> خرید</span> و <span class="ml-1 mr-1 primary--text"> فروش</span> خالص ماهانه
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="total-buy-sell-chart"></chart-export-btn>

    </v-card-title>
    <canvas  height="90" id="total-buy-sell-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'TotalBuyAndSellOfMonthChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartResult: null,
      chartData: {
        type: "line",
        data: {
          labels: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان"],
          datasets: [
            {
              label: "فروش",
              data: [150, 300, 220, 150, 300, 250, 100, 80],
              backgroundColor: "rgba(255, 135, 0,.08)",
              borderColor: "#FF8700",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
            {
              label: "خرید",
              data: [100, 200, 120, 250, 200, 110, 150, 50],
              backgroundColor: "rgba(1, 158, 246, .08)",
              borderColor: "#019EF6",
              borderWidth: 3,
              hoverBorderWidth: 5,

            }
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          legend: {
            display: false
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            //callbacks: {
            //  footer : (tooltipItems) => {
            //    let sum = 0
            //    sum += tooltipItems[0].yLabel
            //    sum -= tooltipItems[1].yLabel
            //    if (sum < 0){
            //      return ' زیان خالص ' + -sum
            //    }
            //    else {
            //      return ' سود خالص ' + sum
            //    }
            //  },
            //}
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .12)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15
                }
              }
            ]
          }
        }
      },
    }
  },
  mounted() {
    this.getChartFromApi()
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/clearBuySaleReportChart`),
        method: "get",
        success: data => {
          this.chartResult = data.results
          this.getData()
        }
      })
    },

    getData() {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []
      this.chartData.data.datasets[1].data = []

      for (let month of this.chartResult){
        this.chartData.data.labels.push(month.title)
        this.chartData.data.datasets[0].data.push(month.sale)
        this.chartData.data.datasets[1].data.push(month.buy)

      }
      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('total-buy-sell-chart');
      new Chart(ctx, this.chartData);
    }

  },

}
</script>